export class FormValidationError extends Error {
  public fieldErrors?: Record<string, string[]>
  public formErrors?: string[]

  constructor(fieldErrors?: Record<string, string[]>, formErrors?: string[]) {
    super('Validation failed')
    this.name = 'ValidationError'
    this.fieldErrors = fieldErrors
    this.formErrors = formErrors
  }
}
